import React from "react";
import { Server } from "lucide-react";
import { AppConfig } from "../../utils/Constants";

const ApiRedirectPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-background-default dark:bg-background-dark text-text-primary dark:text-text-primaryDark font-sans px-4">
      <div className="absolute top-8 left-8">
        <img src={AppConfig.LOGO_URL} alt="Forgeworks Logo" className="w-10" />
      </div>

      <div className="text-center space-y-6 max-w-lg mx-auto">
        <div className="relative inline-block">
          <Server
            className="w-16 h-16 text-secondary animate-pulse"
            aria-label="Server Icon"
          />
        </div>

        <h1 className="text-3xl md:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-secondary via-orange-500 to-red-500 leading-tight">
          This is the API
        </h1>

        <p className="text-body1 text-text-secondary dark:text-text-secondaryDark">
          It seems you've stumbled onto the backend API. This is not where the
          magic happens! Let’s get you back to the right place.
        </p>

        <a
          href={AppConfig.PRODUCT_URL}
          className="inline-block px-6 py-2 text-secondary border-2 border-secondary rounded-lg font-medium transition hover:bg-secondary hover:text-white"
        >
          Go to Forgeworks
        </a>

        <footer className="text-sm text-text-secondary font-bold dark:text-text-secondaryDark mt-8">
          &copy; {new Date().getFullYear()} {AppConfig.PRODUCT_NAME} - All
          rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default ApiRedirectPage;
